module.exports = __webpack_public_path__ + "img/22.c32cf2d3.png";